var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "headset"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C10.1435 5 8.36301 5.7375 7.05025 7.05025C5.7375 8.36301 5 10.1435 5 12V12.1707C5.31278 12.0602 5.64936 12 6 12C7.65685 12 9 13.3431 9 15V17C9 18.6569 7.65685 20 6 20C4.34315 20 3 18.6569 3 17V12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12V17C21 18.3633 20.0906 19.5142 18.8454 19.8792C18.5072 20.8121 17.6547 21.5333 16.6899 22.0157C15.3939 22.6637 13.7065 23 12 23C11.4477 23 11 22.5523 11 22C11 21.4477 11.4477 21 12 21C13.4761 21 14.8409 20.7042 15.7954 20.2269C16.1781 20.0356 16.4442 19.8441 16.627 19.6681C15.6607 19.1698 15 18.1621 15 17V15C15 13.3431 16.3431 12 18 12C18.3506 12 18.6872 12.0602 19 12.1707V12C19 10.1435 18.2625 8.36301 16.9497 7.05025C15.637 5.7375 13.8565 5 12 5ZM19 15C19 14.4477 18.5523 14 18 14C17.4477 14 17 14.4477 17 15V17C17 17.5523 17.4477 18 18 18C18.5523 18 19 17.5523 19 17V15ZM5 15V17C5 17.5523 5.44772 18 6 18C6.55228 18 7 17.5523 7 17V15C7 14.4477 6.55228 14 6 14C5.44772 14 5 14.4477 5 15Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadset);
export default __webpack_public_path__ + "static/media/headset.f7ffddd19576e0eb16acd540abffc53b.svg";
export { ForwardRef as ReactComponent };